import { z } from 'zod'

export const emailSchema = z.string().trim().email()
export const otpCodeSchema = z.string().length(6).regex(/^\d+$/)
